import React, { memo } from 'react';
import { Text, useTheme } from '@Sage/hoi-poi-ui';

const Row = memo(({ description, value }) => {
    const theme = useTheme();
    return (
        <div className="featured-fields__row">
            <Text
                className="featured-fields__row__description"
                color={theme.colors.utility.textSecondary}
            >
                {description}
            </Text>
            <Text className="featured-fields__row__value">{value}</Text>
        </div>
    );
});

Row.displayName = 'Row';

export default Row;
